<template>
  <v-app>
    <AppBar v-if="$route.path.includes('/apply')" />
    <AppBarPanel v-else />
    <v-main>
      <router-view></router-view>
    </v-main>
    <Sponsors v-if="$route.path.includes('/apply') && !this.$store.state.loading" />
    <v-footer v-if="$route.path.includes('/apply') && !this.$store.state.loading" color="primary">
      <AppFooter />
    </v-footer>
  </v-app>
</template>

<script>
import Sponsors from "@/components/home/Sponsors.vue";
//import AppBar from "@/components/app/AppBar";
import AppBar from "@/components/app/AppBar";
import AppBarPanel from "@/components/app/AppBarPanel";
import AppFooter from "@/components/app/AppFooter";
import { isMobile } from "@/services/utils";
import firebase from "firebase";

export default {
  components: {
    Sponsors,
    AppBarPanel,
    AppBar,
    AppFooter
  },
  async mounted() {
    this.$vuetify.theme.dark = false;
    var isMobileFlag = isMobile();
    await this.$store.commit("setIsMobile", isMobileFlag);
    this.createAuthlistener();
  },
  methods: {
    createAuthlistener() {
      var context = this;
      firebase.auth().onAuthStateChanged(async function(user) {
        if (user) {
          await context.$store.commit("setUser", user);
          /*
          context.$router.push("/panel");
          context.$store.commit("setLoadingFlag", false);
          */
          /*
          var firestoreUser = await getUser(user.uid);
          console.log("firestoreUser");
          console.log(firestoreUser);
          await context.$store.commit("setUser", firestoreUser);
          if (firestoreUser.rol == "clinical") {
            context.$router.push("/home");
          } else {
            context.$router.push("/clinical");
          }
          */
          // context.$router.push('/home')
          // User is signed in.
          // ...
        } else {
          // User is signed out.
          console.log("auth user is null");
          await context.$store.commit("setUser", null);
          //context.$router.push("/login");
          // ...
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Merienda";
  src: local("Merienda"),
    url(./fonts/Merienda/Merienda-Regular.ttf) format("truetype");
}
</style>

